import SpotifyIntegrationCard from 'components/SpotifyIntegrationCard/SpotifyIntegrationCard'
import React from 'react'
import { Container } from './Integrations.styled'

interface IntegrationsProps {
  podcastId: string
}

const Integrations: React.FC<IntegrationsProps> = ({ podcastId }) => {
  return (
    <Container>
      <SpotifyIntegrationCard podcastId={podcastId} />
    </Container>
  )
}

export default Integrations
